import axios from 'axios';
import store from '../../store';
import { getCompId, getInstance } from '../more/utils';

export const creategetRequest = (url, params = {}, headers = {}) => {
  return axios.get(url, {
    headers: {
      ...getHeaders(),
      ...headers,
    },
    params,
  });
};

export const createDeleteRequest = (url, params = {}) => {
  return axios.delete(url, {
    headers: getHeaders(),
    params,
  });
};

export const createPostRequest = (url, data = {}) => {
  return axios.post(url, data, {
    headers: getHeaders(),
  });
};

export const getHeaders = () => {
  const {
    accessToken,
    userId,
    expires_in,
    isBusinessApp,
  } = store.getState().appReducer;

  return {
    'Content-Type': 'application/json',
    'x-instagram-token': accessToken,
    'x-instagram-expires-in': expires_in,
    'x-instagram-user-id': userId,
    'x-wix-comp-id': getCompId(),
    'x-wix-instance-id': getInstance(),
    'x-is-business-app': isBusinessApp,
  };
};
